




import {
  computed, ComputedRef, defineComponent, PropType,
} from '@vue/composition-api';
import { useStoryblok } from '~/composables/useStoryblok';
import { Richtext } from 'storyblok-js-client';
import { IRichTextContentAttrs } from './types';

export default defineComponent({
  name: 'RichTextContent',
  props: {
    content: {
      type: Object as PropType<IRichTextContentAttrs>,
      required: true,
    },
  },
  setup(props) {
    const editableReferralContent: ComputedRef<Richtext> = computed(() => props?.content?.content ?? {});

    const { renderRichText } = useStoryblok();
    const referralContent = Object.keys(editableReferralContent.value).length !== 0 ? renderRichText(editableReferralContent.value) : '';

    return {
      referralContent,
      editableReferralContent,
    };
  },
});
